import { Address } from "../../../models/utilities/address";

export class OptimizedStopRequest {

    public sequenceId : number;

    public address : Address;

    constructor(sequence : number, addr : Address) {
        this.sequenceId = sequence;
        this.address = addr;
    }

}

export class CalculateRouteRequest {

    public stops : OptimizedStopRequest[] = [];

    public optimize : boolean;

    constructor(shouldOptimize : boolean) {
        this.optimize = shouldOptimize;
    }

}
